// need for HBILL-616
export enum ROLE {
	TEST_USER = 'Test_user',
	SIMPLE_USER = 'Simple_user',
	USER = 'User',
	PUMB = 'testPUMB',
}
